import React from 'react';
import Navbar from './components/Navbar';
import './App.css';
import Home from './components/pages/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import About from './components/pages/About';
import Journey from './components/pages/Journey';
import Future from './components/pages/Future';
import Blogs from './components/pages/Blogs';
import BlogDetails from './components/pages/BlogDetail';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route exact path="/" element={<Home/>}/>
          <Route path='/about' element={<About/>} />
          <Route path='/journey' element={<Journey/>} />
          <Route path='/future' element={<Future/>} />
          <Route path='/blogs' element={<Blogs/>} />
          <Route path='/blogs/:blogKey' element={<BlogDetails/>} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
